window.pages["contact-us"] = {
    init: function () {
        window.components.contactForm.init();

        $("body").on("click", "#close", function () {
            $(".modal-success").hide();
        });

        $("body").on("click", ".modal-success .backshadow", function () {
            $(".modal-success").hide();
        });

        $("body").on("click", "#close", function () {
            $(".modal-policy").removeClass("modal-policy-active");
        });

        $(window).on("load", function () {
            $("#cidade option:selected").val("");
            $("#estado option:selected").val("");
            $("#pais option:selected").val("");
            $(".ipt-celular").attr("required", true);
        });

        montaUF();

        $("body").on("change", "#assunto", function () {
            if ($(".type-form").val() == "0060") {
                $(".claim-form").show().css("margin-bottom", "20px");            
                $(".claim-required").attr("required", true);

                $("#numero").on("input", function () {
                    var inputVal = $(this).val();
                    if (inputVal.length > 10) {
                        $(this).val(inputVal.substring(0, 10));
                    }
                });

                $("#estado option:selected").val("Acre");
                $("#pais option:selected").val("BR");
            } else {
                $(".claim-form").hide();
                $(".claim-required").attr("required", false);
                $(".ipt-celular").attr("required", true);
                $("#cidade option:selected").val("");
            }
        });
        // $("body").on("click", ".cpf", function () {
        //     if ($(".type-form").val() == "0060") {
        //         $(".cpf-message").show();
        //     }
        // });
        // $("#contactForm input").not('.cpf').on("click", function () {
        //     if ($(".type-form").val() == "0060") {
        //         $(".cpf-message").hide();
        //     }
        // });

        $("body").on("click", "#modal-button", function () {
            $(".modal-policy").addClass("modal-policy-active");
        });

        $("body").on("click", ".button-close", function () {
            $(".modal-policy").removeClass("modal-policy-active");
        });

        $("body").on("click", ".backshadow", function () {
            $(".modal-policy").removeClass("modal-policy-active");
        });

        $("#contactForm").submit(function (e) {
            var input = $("input");
            var error = $(".erro");
            var errorMsg = $("#error-message");

            for (var i = 0; i < input.length; i++) {
                var inp = input[i];
                if (inp.value == "" && inp.hasAttribute("required")) {
                    inp.classList.add("erro");
                    e.preventDefault();
                } else {
                    inp.classList.remove("erro");
                }
                if (error) {
                    errorMsg[0].style.display = "block";
                }
            }

            if ($("textarea").val() == "") {
                $("textarea").css("border", "1px solid red");
                $("#error-message").show();
                e.preventDefault();
            } else {
                $("textarea").css("border", "1px solid #f0ece2");
                $("#error-message").hide();
            }

            if ($(".type-form option:selected").text() == "Escolha...") {
                $(".type-form").addClass("erro");
                $("#error-message").show();
                e.preventDefault();
            } else {
                $(".type-form").removeClass("erro");
                $("#error-message").hide();
            }

            if ($("#age").is(":checked") == false) {
                $("#error-message-age").show();
                e.preventDefault();
            } else {
                $("#error-message-age").hide();
            }

            if ($("#data").is(":checked") == false) {
                $("#error-message-data").show();
                e.preventDefault();
            } else {
                $("#error-message-data").hide();
            }
        });

        $("input").on("input", function () {
            if ($(this).parent().find("input").val() != "") {
                $(this).parent().find("label").addClass("transform");
            } else {
                $(this).parent().find("label").removeClass("transform");
            }
        });

        function toWordCase(str) {
            var prepositions = /\b(de|do|dos|da|das|em|e)\b/gi;
            // Converte a string inteira para minúsculas
            str = str.toLowerCase();
            // Separa a string em palavras
            var words = str.split(" ");
            // Percorre cada palavra e converte a primeira letra em maiúscula, ignorando preposições
            words = words.map(function (word) {
                if (prepositions.test(word)) {
                    return word;
                } else {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
            });
            // Junta as palavras novamente em uma única string
            return words.join(" ");
        }

        function montaCidade(estado, pais) {
            $.ajax({
                type: "GET",
                url: `https://brasilapi.com.br/api/ibge/municipios/v1/${estado}`,
                contentType: "application/json; charset=utf-8",
                async: false,
            }).done(function (response) {
                cidades = "";

                $.each(response, function (c, cidade) {
                    nomeCidade = toWordCase(cidade.nome);
                    cidades +=
                        '<option value="' +
                        nomeCidade +
                        '">' +
                        nomeCidade +
                        "</option>";
                });

                $("#cidade").html(cidades);
            });
        }

        function montaUF() {
            $.ajax({
                type: "GET",
                url: "https://brasilapi.com.br/api/ibge/uf/v1",
                async: false,
            }).done(function (response) {
                estados = "";
                response.sort(function (a, b) {
                    var nomeA = a.nome.toUpperCase();
                    var nomeB = b.nome.toUpperCase();
                    if (nomeA < nomeB) {
                        return -1;
                    }
                    if (nomeA > nomeB) {
                        return 1;
                    }

                    return 0;
                });
                $.each(response, function (e, estado) {
                    estados +=
                        '<option value="' +
                        estado.sigla +
                        '">' +
                        estado.nome +
                        "</option>";
                });

                $("#estado").html(estados);
                montaCidade($("#estado").val(), pais);
                $("#estado").change(function () {
                    montaCidade($(this).val(), pais);
                });
            });
        }

        function montaPais() {
            $.ajax({
                type: "GET",
                url: "http://api.londrinaweb.com.br/PUC/Paisesv2/0/1000",
                contentType: "application/json; charset=utf-8",
                dataType: "jsonp",
                async: false,
            }).done(function (response) {
                console.log({ response });
                paises = "";

                $.each(response, function (p, pais) {
                    paises +=
                        '<option value="' +
                        pais.Sigla +
                        '">' +
                        pais.Pais +
                        "</option>";
                });

                $("#pais").html(paises);
                montaUF($("#pais").val());
                $("#pais").change(function () {
                    if ($("#pais").val() == "BR") {
                        $("#estado").remove();
                        $("#cidade").remove();
                        $("#campo_estado").append(
                            '<select id="estado" name="estado"></select>'
                        );
                        $("#campo_cidade").append(
                            '<select id="cidade" name="cidade"></select>'
                        );

                        montaUF("BR");
                    } else {
                        $("#estado").remove();
                        $("#cidade").remove();
                        $("#campo_estado").append(
                            '<input type="text" name="estado" id="estado">'
                        );
                        $("#campo_cidade").append(
                            '<input type="text" name="cidade" id="cidade">'
                        );
                    }
                });
            });
        }
    },
};
